import React from "react";
import TableList from "src/components/Admin/TableList/TableList";

export default function Planner() {
  return (
    <>
      <div>
        <TableList Role="Planner" />
      </div>
    </>
  );
}
